import { useRouter } from 'next/router';
import { useEffect } from 'react';

import usePressListingStore, { setPressSearch, updatePressFilters } from 'layout/Listing/variants/press/store';

const usePressFilterSearchParam = () => {
  const router = useRouter();
  const activeFilters = usePressListingStore(state => state.filters);
  const activeSearch = usePressListingStore(state => state.search);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const search = params.get('s');
    const category = params.get('category');

    if (search) {
      setPressSearch(search);
    }

    if (category && activeFilters === 'All') {
      updatePressFilters(router, category);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (activeSearch) {
      params.set('s', activeSearch);
    } else {
      params.delete('s');
    }

    const basePath = router.asPath.split('?')[0];
    const newUrl = `${basePath}?${params.toString()}`;
    router.replace(newUrl, undefined, { shallow: true, scroll: false });
  }, [activeSearch]);
};

export default usePressFilterSearchParam;
